export default "__VITE_ASSET__CMtOKDu___"